import { Link } from "react-router-dom";
import rolando from "../../img/rolando.jpg";
import "./sidebar.css";
import { useEffect, useState } from "react";
import axios from "axios";
import SocialIcons from "../socialIcons/SocialIcons";
import Gallery from "../gallery/Gallery";

function Sidebar({ aboutBlog: aboutBlogProp, withGallery = false }) {
  const [aboutBlog, setAboutBlog] = useState({});

  // const { aboutBlog: aboutBlogFromContext } = useBlog();

  useEffect(() => {
    const getAboutBlog = async () => {
      const res = await axios.get(
        process.env.REACT_APP_API_URL +
          "/blog-infos?populate[about_photo]=true&populate[links]=true",
        // {
        //   headers: {
        //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
        //   },
        // }
      );
      // if (res.data.length > 0) {
      //only getting the first entry of the table
      setAboutBlog(res.data.data[0]);
      // }
    };

    getAboutBlog();
  }, []);

  return (
    <div>
      <div className="sidebar shadow-elevation-lightbg-low">
        <div className="sidebarItem">
          <span className="sidebarTitle shadow-elevation-lightbg-low">
            ABOUT
          </span>
          <img
            src={`${process.env.REACT_APP_UPLOAD_URL}${aboutBlog.about_photo?.formats?.small?.url}`}
            alt="about"
          />
          <div className="sidebarContent">
            {/* <h2>{aboutBlog.title}</h2> */}
            {/* get only the first sentence */}

            <p className="">{aboutBlog.description?.split(".")[0]}</p>
            <Link className="link" to={`/about`}>
              Read More <i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div>
        </div>

        <div className="sidebarItem">
          {aboutBlog?.links && <SocialIcons links={aboutBlog?.links} />}
        </div>
      </div>
      {withGallery && <Gallery />}
    </div>
  );
}

export default Sidebar;
